import { render, staticRenderFns } from "./ContributionDetail.vue?vue&type=template&id=9ba1bed0&scoped=true&"
import script from "./ContributionDetail.vue?vue&type=script&lang=js&"
export * from "./ContributionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba1bed0",
  null
  
)

export default component.exports